import { render, staticRenderFns } from "./promo-carousel.vue?vue&type=template&id=5d96bf5f"
import script from "./promo-carousel.vue?vue&type=script&lang=js"
export * from "./promo-carousel.vue?vue&type=script&lang=js"
import style0 from "./promo-carousel.vue?vue&type=style&index=0&id=5d96bf5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports